// extracted by mini-css-extract-plugin
module.exports = {"bkw-Q":"Q_bkw-Q__q074h"};